<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg6 xs6>
                      <v-text-field v-model="filters.inter" :label="filtersLabel.inter" :error-messages="errors.collect('inter')" data-vv-name="inter" :data-vv-as="filtersLabel.inter" v-validate="'entry|max:8'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg6 xs6>
                      <v-text-field v-model="filters.intermediaryName" :label="filtersLabel.intermediaryName" :error-messages="errors.collect('intermediaryName')" data-vv-name="intermediaryName" :data-vv-as="filtersLabel.intermediaryName" v-validate="'name|max:128'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg6 xs6>
                      <v-autocomplete :items="interGroupList" v-model="filters.interGroupList" :label="filtersLabel.interGroupList" item-text="label" item-value="value" data-vv-name="interGroupList" :data-vv-as="filtersLabel.interGroupList" :error-messages="errors.collect('interGroupList')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg6 xs6>
                      <v-autocomplete :items="statusList" v-model="filters.suspended" column :label="filtersLabel.suspended" item-text="label" item-value="value" :error-messages="errors.collect('suspended')" data-vv-name="suspended" :data-vv-as="filtersLabel.suspended"></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg6 xs12>
                      <cal-picker :label="filtersLabel.dateOpened" v-model="filters.dateOpened" :error-messages="errors.collect('dateOpened')" data-vv-name="dateOpened" :data-vv-as="filtersLabel.dateOpened" ></cal-picker>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <div class="headline">Intermediary Listing</div>
            </div>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="inter" :loading="loading" :no-data-text="noDataText">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.inter }}</td>
              <td class="text-xs-right">{{ props.item.intermediaryName }}</td>
              <td class="text-xs-right">{{ props.item.interGroupName}}</td>
              <td class="text-xs-right">{{ formatDate(props.item.dateOpened) }}</td>
              <td class="text-xs-right">{{ formatDate(props.item.dateClosed) }}</td>
              <td class="text-xs-right">{{ formatBoolean(props.item.suspended) }}</td>
              <td class="text-xs-right">
                <table-action :rowData="props" query :review="checkAccess(['intermediaryReview'])" @query="doQuery" @review="doReview"></table-action>
              </td>
            </template>
          </v-data-table>
        </v-card>
        <div class="pt-2" v-if="checkAccess(['intermediaryReview'])">
          <v-btn color="primary" @click="doNew">
            Add New Intermediary
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </page>
</template>

<script>
import clone from 'clone'
import toDate from 'date-fns/toDate'
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { ADMININTERMEDIARY_INTERGROUPLIST } from '@/store/types'
import { removeTime, formatDisplayDateTime2, formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      headers: [
        { text: 'Intermediary Code', align: 'left', value: 'interId' },
        { text: 'Intermediary Name', align: 'right', value: 'intermediaryName' },
        { text: 'Intermediary Group', align: 'right', value: 'interGroup' },
        { text: 'Date Opened', align: 'right', value: 'dateOpened' },
        { text: 'Date Closed', align: 'right', value: 'dateClosed' },
        { text: 'Suspended', align: 'right', value: 'suspended' },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      filters: {
        inter: null,
        intermediaryName: null,
        suspended: null,
        interGroupCode: null,
        interGroupName: null,
        dateOpened: null,
        interGroupList: null
      },
      filtersLabel: {
        inter: 'Intermediary Code',
        intermediaryName: 'Intermediary Name',
        suspended: 'Status',
        interGroupList: 'Intermediary Group',
        dateOpened: 'Select Date'
      },
      statusList: [
        { label: 'Suspended', value: true },
        { label: 'Not Suspended', value: false },
        { label: 'All', value: null }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    interGroupList() {
      return this.$store.state.adminInter.interGroupList
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiUrl = this.$store.state.adminInter.menu.IntermediariesList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.dateOpened) {
            massageFilters.dateOpened = formatDisplayDateTime2(removeTime(massageFilters.dateOpened))
          }

          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((intermediary) => {
                const convertInter = {
                  inter: intermediary.inter,
                  intermediaryName: intermediary.name,
                  suspended: intermediary.suspended,
                  interGroupCode: intermediary.interGroupCode,
                  interGroupName: intermediary.interGroupName,
                  officeNo: intermediary.officeNo,
                  faxNo: intermediary.faxNo,
                  dateOpened: intermediary.dateOpened,
                  dateClosed: intermediary.dateClosed
                }
                this.items.push(convertInter)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.inter = null
      this.filters.intermediaryName = null
      this.filters.suspended = null
      this.filters.dateOpened = null
      this.filters.dateClosed = null
      this.filters.interGroupList = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doQuery(data) {
      if (data && data.item && data.item.inter) {
        this.$router.push({ name: 'queryProfile', params: { inter: data.item.inter } })
      }
    },
    doReview(data) {
      if (data && data.item && data.item.inter) {
        this.$router.push({ name: 'reviewProfile', params: { inter: data.item.inter } })
      }
    },
    doNew() {
      if (this.checkAccess(['intermediaryReview'])) {
        this.$router.push({ name: 'reviewProfile', params: { inter: 'new' } })
      } else {
        this.$snotify.warning('You do not have access to this resource')
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(toDate(xDate))
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    },
    async getInterGroupList() {
      const apiURI = this.$store.state.adminInter.menu.interGroup
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.$store.commit(ADMININTERMEDIARY_INTERGROUPLIST, data.data.interGroupList)
        }
      } catch (err) {
        throw err
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData(true)
    Promise.all([this.getInterGroupList()])
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
